import { styled } from '@mui/material/styles';

import { Link } from '@mui/material';

const StyledCtaButton = theme => `
  text-decoration-color: ${theme.palette.primary.main};
  transition-property: color;
  transition-duration: ${theme.transitions.duration.short}ms;
  transition-timing-function: ${theme.transitions.easing.easeInOut};

  :active,
  :focus {
    color: ${theme.palette.primary.action};
  }

  ${theme.breakpoints.up('desktop')} {
    :hover {
      color: ${theme.palette.primary.action};
    }
  }
`;

const StyledMuiExternalLink = styled('a')(
  ({ theme }) => `
    ${StyledCtaButton(theme)};
  `,
);

const StyledMuiLink = styled(Link)(
  ({ theme }) => `
    ${StyledCtaButton(theme)};
  `,
);

export { StyledMuiLink, StyledMuiExternalLink };
